import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  FaChevronDown, FaChevronUp,
} from 'react-icons/fa';
import { useState } from 'react';
import withSpinner from '../../../../../HOCs/withSpinner';
import { SearchStatus } from '../../../../../constants';
import ReferLabelRoomDescription from '../ReferLabelRoomDescriptionDetail';
import { removeCommissionTerms } from '../../../../../helpers/formatters/formatRoomDescription';

export const getImprovedRawDescription = (description) => description
  .replace(/null/g, '')
  .replace(/\n+/g, '\n')
  .replace(/\n/g, '<br>');

const DetailedRoomDescription = ({
  description,
  rawDescription,
  doAllowShowingRawRateDescription,
  room,
  doShowAgentCommission,
}) => {
  const [doShowRawDescription, setDoShowRawDescription] = useState(false);
  const { travelAgency } = useSelector((store) => store.user);
  const viewRawDescriptionLabel = travelAgency?.settings?.viewRawDescriptionLabel;
  const hideRawDescriptionLabel = travelAgency?.settings?.hideRawDescriptionLabel;

  const handleViewRawDescriptionClick = () => {
    setDoShowRawDescription((s) => !s);
  };

  return (
    <>
      {description && withSpinner(() => (
        <>
          {description && description.description && description.description.sections ? (
            <div className="container mx-auto p-6">
              <h1 className="text-xl font-semibold mb-4">{description.description.roomTitle}</h1>

              {description.description.sections && description.description.sections.map((s) => (
                <>
                  {s.infos && s.infos.length > 0 && (
                    <section className="mb-3">
                      <h2 className="text font-semibold mb-2">
                        {s.sectionTitle}
                        {(
                          ['additional benefits', 'rate inclusions'].includes(s.sectionTitle?.toLowerCase())
                          || s.sectionTitle?.toLowerCase().includes('benefits')
                          || s.sectionTitle?.toLowerCase().includes('offers')
                          || s.sectionTitle?.toLowerCase().includes('bonuses')
                        ) && ' (refer to raw description to confirm)'}
                      </h2>
                      <ul className="list-none pl-0 grid grid-cols-2 md:grid-cols-3 gap-x-5 gap-y-2">
                        {s.infos.map((i) => (
                          <li key={i}>{i}</li>
                        ))}
                      </ul>
                    </section>
                  )}
                </>
              ))}

              <ReferLabelRoomDescription
                room={room}
              />
              <div className="text-left py-2 text-sm">
                <b>Warning: </b>
                {' '}
                {`This rate description has been enhanced by AI and may not be 100% accurate. You are
                responsible for verifying all details (click ${viewRawDescriptionLabel || 'View raw description'} link below)`}
              </div>
              {doAllowShowingRawRateDescription && rawDescription && (
                <>
                  <a
                    className="text-base text-theme cursor-pointer z-10 flex items-center"
                    role="button"
                    tabIndex="-1"
                    onClick={() => handleViewRawDescriptionClick()}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handleViewRawDescriptionClick();
                      }
                    }}
                  >
                    {!doShowRawDescription && (
                      <>
                        { viewRawDescriptionLabel || 'View raw description as returned by property' }
                        <FaChevronDown className="pl-1" />
                      </>
                    )}
                    {doShowRawDescription && (
                      <>
                        { hideRawDescriptionLabel || 'Hide raw description as returned by property' }
                        <FaChevronUp className="pl-1" />
                      </>
                    )}
                  </a>
                  {doShowRawDescription && (
                    <div
                      className="bg-body-0 p-5 font-mono"
                      dangerouslySetInnerHTML={{
                        __html: getImprovedRawDescription(doShowAgentCommission
                          ? rawDescription
                          : removeCommissionTerms(rawDescription)),
                      }}
                    />
                  )}
                </>
              )}

            </div>
          ) : (
            <div>
              {rawDescription && (
              <div
                dangerouslySetInnerHTML={{
                  __html: getImprovedRawDescription(doShowAgentCommission
                    ? rawDescription
                    : removeCommissionTerms(rawDescription)),
                }}
              />
              )}
            </div>
          )}
        </>
      ), description.status === SearchStatus.SEARCHING, 'Getting room description...')}
    </>
  );
};

DetailedRoomDescription.propTypes = {
  description: PropTypes.shape({
    status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    description: PropTypes.shape({
      roomTitle: PropTypes.string,
      sections: PropTypes.arrayOf(PropTypes.shape({
        sectionTitle: PropTypes.string,
        infos: PropTypes.arrayOf(PropTypes.string),
      })),
    }),
  }).isRequired,
  room: PropTypes.shape().isRequired,
  rawDescription: PropTypes.string,
  doAllowShowingRawRateDescription: PropTypes.bool,
  doShowAgentCommission: PropTypes.bool,
};

DetailedRoomDescription.defaultProps = {
  rawDescription: undefined,
  doAllowShowingRawRateDescription: false,
  doShowAgentCommission: true,
};

export default DetailedRoomDescription;
